import React from "react";
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer"; 
import homebanner from "../assets/home-banner.png"; 
import Pagetitlesection from "../components/pagetitlesection"; 

function TermsandConditions() {
  return (
    <>
      <Header />
      <div className="page-body-container">
        <Pagetitlesection title="Terms and Conditions" backgroundImage={homebanner} />

  <div className="md:container mx-auto px-6 sm:px-6 py-10 flex flex-col items-center justify-center ">
    <section className="bg-white p-4 sm:p-10 rounded-lg shadow-lg text-gray-800 leading-relaxed max-w-5xl w-full">
      <h2 className="md:text-3xl text-xl font-bold mb-6 text-center text-primarycolor">Welcome to Giffypedia</h2>
      <p className="mb-6 text-center text-gray-600">
        The platform where individuals can create and share their personal profiles, achievements, and stories.<br />
        By using our services, you agree to follow these Terms and Conditions. Please read them carefully.
      </p>

      <ol className="list-decimal list-inside space-y-6">
        <li>
          <span className="font-semibold text-primarycolor">Acceptance of Terms</span>
          <ul className="list-disc list-inside ml-5 mt-2 text-gray-700">
            <li>
              By accessing or using Giffypedia, you agree to be bound by these Terms and our Privacy Policy. If you do not agree, please discontinue using the site.
            </li>
          </ul>
        </li>
        <li>
          <span className="font-semibold text-primarycolor">User Accounts</span>
          <ul className="list-disc list-inside ml-5 mt-2 text-gray-700">
            <li>You are responsible for providing accurate, up-to-date information when creating your profile.</li>
            <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
            <li>You must be at least 13 years old to use this platform.</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold text-primarycolor">Content Submission</span>
          <ul className="list-disc list-inside ml-5 mt-2 text-gray-700">
            <li>You may upload photos, text, and other information relevant to your profile.</li>
            <li>You confirm that you have the rights to any content you submit.</li>
            <li>You must not upload illegal, offensive, or copyright-infringing materials.</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold text-primarycolor">Usage Restrictions</span>
          <ul className="list-disc list-inside ml-5 mt-2 text-gray-700">
            <li>You agree not to use Giffypedia for fraudulent or harmful activities.</li>
            <li>You agree not to collect or harvest personal data from other users without consent.</li>
            <li>You agree not to interfere with the operation of the site.</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold text-primarycolor">Intellectual Property</span>
          <ul className="list-disc list-inside ml-5 mt-2 text-gray-700">
            <li>All content on Giffypedia, except user-submitted profiles, is owned by Giffypedia and protected by copyright laws.</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold text-primarycolor">Termination</span>
          <ul className="list-disc list-inside ml-5 mt-2 text-gray-700">
            <li>We may suspend or delete your account if you violate these terms.</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold text-primarycolor">Limitation of Liability</span>
          <ul className="list-disc list-inside ml-5 mt-2 text-gray-700">
            <li>Giffypedia is not responsible for inaccuracies in user-submitted content or damages resulting from use of the platform.</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold text-primarycolor">Changes to Terms</span>
          <ul className="list-disc list-inside ml-5 mt-2 text-gray-700">
            <li>We may update these Terms from time to time. Continued use means you accept the updated Terms.</li>
          </ul>
        </li>
      </ol>

      <div className="mt-8 text-center">
        <span className="font-semibold text-gray-700">Contact: For any questions about these Terms, email us at</span>
        <a href="mailto:Giffypedia@gmail.com" className="text-blue-600 underline ml-2">giffypedia@gmail.com</a>
      </div>
    </section>
  </div>

        <Footer />
      </div>
    </>
  );
}

export default TermsandConditions;
